import { useEffect } from "react";

export default function LotSizeField({
  register,
  filterData,
  fieldNamePrefix = "",
  setValue,
  watch,
}) {
  const minLotsize = watch(`${fieldNamePrefix}_min_lotsize`);
  const maxLotsize = watch(`${fieldNamePrefix}_max_lotsize`);

  useEffect(() => {
    if (setValue && minLotsize !== undefined) {
      setValue("min_lotsize", minLotsize);
      setValue("building_min_lotsize", minLotsize);
      setValue("size_min_lotsize", minLotsize);
    }
  }, [minLotsize, setValue]);

  useEffect(() => {
    if (setValue && maxLotsize !== undefined) {
      setValue("max_lotsize", maxLotsize);
      setValue("building_max_lotsize", maxLotsize);
      setValue("size_max_lotsize", maxLotsize);
    }
  }, [maxLotsize, setValue]);
  return (
    <div className="form_blk">
      <h6>Lot Size (AC)</h6>
      <div className="half_flex">
        <div className="half_field">
          <input
            type="text"
            name={`${fieldNamePrefix}_min_lotsize`}
            id={`${fieldNamePrefix}_min_lotsize`}
            className="input"
            placeholder="Min Acres"
            {...register(`${fieldNamePrefix}_min_lotsize`)}
            defaultValue={filterData?.[`${fieldNamePrefix}_min_lotsize`]}
          />
        </div>
        <span></span>
        <div className="half_field">
          <input
            type="text"
            name={`${fieldNamePrefix}_max_lotsize`}
            id={`${fieldNamePrefix}_max_lotsize`}
            className="input"
            placeholder="Max Acres"
            {...register(`${fieldNamePrefix}_max_lotsize`)}
            defaultValue={filterData?.[`${fieldNamePrefix}_max_lotsize`]}
          />
        </div>
      </div>
    </div>
  );
}
